import { useGetBlogs } from "../../hooks/useGetBlogs";
import styles from "./Blog.module.css";
import Spinner from "../Spinner/Spinner";
import { format } from "date-fns";
import { Link } from "react-router-dom";

export const Blogs = () => {
  const { blogs, loading, error } = useGetBlogs();

  if (loading) return <Spinner />;
  if (error) return <div>Error: {error}</div>;

  const sortedBlogs = [...blogs].sort(
    (a, b) => Number(a.order) - Number(b.order)
  );

  const topBlogs = sortedBlogs.slice(0, 5);
  const allBlogs = sortedBlogs.slice(5);

  return (
    <div className={styles.page}>
      <div className={styles.headerSection}>
        <div className={styles.pageHeading}>
          <h1>Blogs</h1>
        </div>
      </div>

      <section className={styles.mainSection}>
        <div className={styles.container}>
          <div className={styles.blogsGrid}>
            <div className={styles.leftColumn}>
              {topBlogs[1] && <BlogMainCard blog={topBlogs[1]} />}
              <hr className={styles.divider} />
              {topBlogs[2] && <BlogMainCard blog={topBlogs[2]} />}
            </div>
            <div className={styles.centerColumn}>
              {topBlogs[0] && <BlogMainCard blog={topBlogs[0]} isCentred />}
            </div>
            <div className={styles.rightColumn}>
              {topBlogs[3] && <BlogMainCard blog={topBlogs[3]} />}
              <hr className={styles.divider} />
              {topBlogs[4] && <BlogMainCard blog={topBlogs[4]} />}
            </div>
          </div>
        </div>
      </section>

      {allBlogs.length > 0 && (
        <section className={styles.secondarySection}>
          <div className={styles.container}>
            
            <div className={styles.secondaryGrid}>
              {allBlogs.map((blog) => (
                <BlogCard key={blog._id} blog={blog} />
              ))}
            </div>
          </div>
        </section>
      )}

    </div>
  );
};

const BlogMainCard = ({ blog, isCentred = false }) => {
  return (
    <Link
      to={`/blogs/${blog.slug ?? blog._id}`}
      className={`${styles.blogMainCard} ${
        isCentred ? styles.blogMainCardCentred : ""
      }`}
    >
      <div
        className={`${styles.blogMainCardLink} ${
          isCentred
            ? styles.blogMainCardLinkCentred
            : styles.blogMainCardLinkSmall
        }`}
      >
        <img
          src={blog.image}
          alt={blog.heading}
          className={`${styles.blogMainCardImage} ${
            isCentred
              ? styles.blogMainCardImageCentred
              : styles.blogMainCardImageSmall
          }`}
        />
      </div>
      <div className={isCentred ? styles.blogMainCardContentCentred : ""}>
        <h4
          className={`${styles.blogMainCardHeading} ${
            isCentred
              ? styles.blogMainCardHeadingCentred
              : styles.blogMainCardHeadingSmall
          }`}
        >
          {blog.heading}
        </h4>
        <p className={styles.blogMainCardDate}>
          {format(new Date(blog.createdAt), "dd MMM, yyyy")}
        </p>
      </div>
    </Link>
  );
};

export const BlogCard = ({ blog }) => {
  return (
    <Link to={`/blogs/${blog.slug ?? blog._id}`} className={styles.blogCard}>
      <div className={styles.blogCardImageLink}>
        <img
          src={blog.image}
          alt={blog.heading}
          className={styles.blogCardImage}
        />
      </div>
      <div className={styles.blogCardContent}>
        <div className={styles.blogCardHeadingWrapper}>
          <span className={styles.blogCardHeadingText}>{blog.heading}</span>
        </div>
        <div className={styles.blogCardDate}>
          {format(new Date(blog.createdAt), "dd MMM, yyyy")}
        </div>
      </div>
    </Link>
  );
};
